export enum AllowedGroups {
   DICTIONARY_ADMIN = <any>"DICTIONARY_ADMIN",
   DICTIONARY_EDITOR = <any>"DICTIONARY_EDITOR"
}